var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "contactInput",
      staticClass: "contacts-input-div",
      on: { click: _vm.handleFocus, focusout: _vm.handleBlur }
    },
    [
      !_vm.isInputVisible && _vm.emailAddresses.length <= 0
        ? _c(
            "span",
            {
              staticClass:
                "contacts-input-placeholder typographies-paragraph-medium-regular"
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.localizedTexts.searchContacts) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.tagValues, function(emailAddress) {
        return _c("CompassTagInteractive", {
          key: emailAddress.id,
          staticClass: "contacts-tags",
          attrs: {
            size: "small",
            color: _vm.getTagColor(emailAddress),
            modelValue: emailAddress.id,
            valueLabel: _vm.findParticipant(emailAddress.id)
          },
          on: {
            "tag-remove": function($event) {
              return _vm.handleRemoveTag(emailAddress.id)
            }
          }
        })
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isInputVisible,
            expression: "isInputVisible"
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input,
            expression: "input"
          }
        ],
        ref: "contactsInput",
        staticClass: "contacts-input typographies-paragraph-medium-regular",
        attrs: { maxlength: "320" },
        domProps: { value: _vm.input },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.input = $event.target.value
            },
            _vm.onInput
          ],
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, ",", undefined, $event.key, undefined)
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleEmail($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleEmail($event)
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleEmail($event)
            }
          ],
          focus: _vm.handleFocus
        }
      }),
      _vm._v(" "),
      _c(
        "CompassDropdown",
        {
          ref: "contactsDropdown",
          attrs: {
            noResultsLabel: _vm.localizedTexts.noResults,
            value: _vm.valueFromAutoComplete,
            isVisible: _vm.isDropdownVisible,
            noResults: _vm.dataFromAutocomplete.length === 0,
            parentRef: "contactInput",
            loading: _vm.isDropdownLoading,
            dropdownClass: "contacts-dropdown"
          }
        },
        _vm._l(_vm.dataFromAutocomplete, function(item) {
          return _c(
            "CompassDropdownOption",
            {
              key: item.id,
              attrs: {
                label: item.first_name + " " + item.last_name,
                value: item.id
              },
              on: {
                itemSelected: function($event) {
                  return _vm.onItemSelected(item.id)
                }
              }
            },
            [
              _c("CompassAvatar", {
                attrs: { initials: _vm.getInitials(item), size: "extra-small" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "contacts-dropdown-item-text" }, [
                _vm._v(_vm._s(item.first_name) + " " + _vm._s(item.last_name))
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }